export default "__VITE_ASSET__d27cac3b__"